import { alpha, Box, MenuItem, Select, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";

export default function MainSelect({
    label,
    value,
    onChange,
    options,
    size = "small",
    sx,
}) {
    const { mode } = useColorScheme();
    return (
        <Box>
            {label && <Typography variant="body2" sx={{ marginBottom: "4px" }}>
                {label}
            </Typography>}
            <Select
                size={size}
                value={value}
                onChange={onChange}
                fullWidth
                sx={{
                    ...sx,
                    '& .MuiSelect-outlined': {
                        backgroundColor: alpha(Constants.Colors[mode].background, 1),
                        fontSize: "14px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[mode].border,
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[mode].accent,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: Constants.Colors[mode].accent,
                    },
                }}
            >
                {options?.map((option) => (
                    <MenuItem
                        key={option.value}
                        value={option.value}
                        sx={{
                            "&:hover": {
                                backgroundColor: alpha(Constants.Colors[mode].accent, 0.8),
                            },
                            "&.Mui-selected": {
                                backgroundColor: alpha(Constants.Colors[mode].accent, 1),
                                "&:hover": {
                                    backgroundColor: alpha(Constants.Colors[mode].accent, 0.8),
                                }
                            }
                        }}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </Box>
    );
}